import React from 'react';
import useTranslate from '../../../../customHooks/useTranslate';

const SupplementAdditionalInfo = () => {
    const translate = useTranslate();

    return (
        <div>
            <p className='text-size-12 '>
                <span className='font-weight-600'>
                    {translate('pay_on_site')}:{' '}
                </span>
                <span className='font-weight-400'>
                    {translate('pay_on_site_description')}
                </span>
            </p>
            <p className='text-size-12 '>
                <span className='font-weight-600'>
                    {translate('payment_included_in_cost')}:{' '}
                </span>
                <span className='font-weight-400'>
                    {translate('payment_included_in_cost_description')}
                </span>
            </p>
        </div>
    );
};

export default SupplementAdditionalInfo;
